import type { CSSObject } from '@emotion/react'
import { Spacing } from '@opallabs/gem'

export const label: CSSObject = {
  '* + &, & + *': {
    marginInlineStart: Spacing.S,
  },
}
